<template>
  <!-- Modal -->
  <div class="loginForm modal fade" id="bsModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title" id="bsModalLabel">{{title}}</h4>
        </div>
        <div class="modal-body">
          {{description}}
          <div v-if="checkText">
            <div class="tree-content tree--small" style="padding: 10px 0px;" @click="isChecked=!isChecked">
              <i :class="['tree-checkbox', isChecked?'checked':'']"></i>
              <span tabindex="-1" class="tree-anchor">
                <span class="tree-text" style="white-space: nowrap;">{{checkText}}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button v-show="confirmText" type="button" class="btn btn-danger" @click="confirm">{{confirmText}}</button>
          <button v-show="cancelText" type="button" class="btn btn-default" @click="cancel">{{cancelText}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// const ModalTypes = ['modal-primary', 'modal-success', 'modal-info', 'modal-warning', 'modal-danger']
export default {
  mounted () {
    this.$bus.$on('modal-open', (args) => {
      console.log(args)
      this.type = args.type
      this.title = args.title
      this.description = args.description
      this.checkText = args.checkText
      this.isChecked = args.isChecked
      this.confirmText = args.confirmText
      this.cancelText = args.cancelText
      this.confirmBeforeHook = args.confirmBefore
      this.confirmAfterHook = args.confirmAfter
      this.forceAfterHook = args.forceAfter
      this.cancelBeforeHook = args.cancelBefore
      this.cancelAfterHook = args.cancelAfter

      $('#bsModal').modal('show')
    })
    $('#bsModal').on('show.bs.modal', (e) => {
    })

    $('#bsModal').on('hidden.bs.modal', (e) => {
      // this.confirmAfterHook()
      // this.cancelAfterHook()
      // this.resetProperties()
    })
  },
  data () {
    return {
      type: '',
      title: '',
      description: '',
      checkText: '',
      confirmText: '',
      cancelText: '',
      confirmBeforeHook: () => {},
      confirmAfterHook: () => {},
      forceAfterHook: () => {},
      cancelBeforeHook: () => {},
      cancelAfterHook: () => {},
      isChecked: false
    }
  },
  methods: {
    confirm: function () {
      // this.confirmBeforeHook()
      $('#bsModal').modal('hide')
      this.confirmAfterHook()
      if (this.isChecked) {
        this.forceAfterHook()
      }
      this.resetProperties()
    },
    cancel: function () {
      // this.cancelBeforeHook()
      $('#bsModal').modal('hide')
      this.cancelAfterHook()
      this.resetProperties()
    },
    resetProperties: function () {
      this.type = ''
      this.title = ''
      this.description = ''
      this.checkText = ''
      this.isChecked = false
      this.confirmText = ''
      this.cancelText = ''
      this.confirmBeforeHook = () => {}
      this.confirmAfterHook = () => {}
      this.forceAfterHook = () => {}
      this.cancelBeforeHook = () => {}
      this.cancelAfterHook = () => {}
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// Modal.vue?415bd42d